// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseContactPreferenceModel {
    static getAttributeTypeMap() {
        return CaseContactPreferenceModel.attributeTypeMap;
    }
}
CaseContactPreferenceModel.discriminator = undefined;
CaseContactPreferenceModel.additionalProperties = false;
CaseContactPreferenceModel.attributeTypeMap = [
    {
        "name": "contactInfoType",
        "baseName": "contactInfoType",
        "type": "CaseContactInformationType"
    },
    {
        "name": "isOptedIn",
        "baseName": "isOptedIn",
        "type": "boolean"
    },
    {
        "name": "isPreferred",
        "baseName": "isPreferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=caseContactPreferenceModel.js.map